import { Pill, Tooltip } from '@mantine/core';
import { MouseEvent } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    ticketNumber: string;
    isEditable?: boolean;
    onEdit?: () => void;
}

export const TicketNumberPill = ({ ticketNumber, isEditable = false, onEdit }: Props) => {
    const handleClick = (e: MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation();
        onEdit?.();
    };

    const pillContent = (
        <Pill
            className={cn(
                'h-5 text-xs xl:h-6 xl:text-sm',
                isEditable && 'cursor-pointer transition hover:bg-slate-200'
            )}
            classNames={{ label: 'leading-5 xl:leading-[1.375rem]' }}
            onClick={isEditable && onEdit ? handleClick : undefined}
        >
            {ticketNumber}
        </Pill>
    );

    if (isEditable && onEdit) {
        return <Tooltip label="Ticketnummer ändern">{pillContent}</Tooltip>;
    }

    return pillContent;
};
